import * as constants from "../constants/constants";

export interface ImpressionState {
    impressionRecords: any
    impressionRecordsPagination: any
    projectsReadyForImpression: any
    fetchedImpression: any,
    impressionNeededInfo: any
}

const initialState = () => {
    return {
        impressionRecords: [],
        impressionRecordsPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        projectsReadyForImpression: [],
        fetchedImpression: {},
        impressionNeededInfo: {}
    }
}

const admin = (state: ImpressionState = initialState(), action: any) => {
    switch (action.type) {
        case constants.FETCH_IMPRESSION_RECORDS: {
            return {
                ...state,
                impressionRecords: action.payload.data || action.payload,
                impressionRecordsPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.impressionRecordsPagination
            };
        }
        case constants.FETCH_PROJECTS_FOR_IMPRESSION: {
            return {
                ...state,
                projectsReadyForImpression: action.payload
            };
        }
        case constants.FETCH_IMPRESSION: {
            return {
                ...state,
                fetchedImpression: action.payload
            };
        }
        case constants.FETCH_IMPRESSION_NEEDED_INFO: {
            return {
                ...state,
                impressionNeededInfo: action.payload
            };
        }
    }
    return state;
}

export default admin;